import React from "react";
import { DatePicker, Input, Select } from "antd";
import dayjs from "dayjs";
import PhoneInput from "react-phone-number-input";
import { useLocation } from "react-router-dom";
import { useTranslation } from "../../i18n/LanguageContext";

const Sections = ({
   sectionName,
   propertyName,
   propertyValue,
   isEditMode,
   isEditPassword,
   isEditEmail,
   handleChange,
   name,
   fieldType,
   options = [],
   onSelectChange,
   isRequired,
   type,
   icon,
   handleToggle
}) => {
   const { t } = useTranslation();
   const location = useLocation();
   const isProfilePage = location.pathname.includes("profile-information");
   const findOption = (value) => options.find((option) => option.value === value);
   return (
      <div style={{ display: "flex", flexDirection: "column", justifyContent: "flex-end" }}>
         {sectionName && (
            <span
               style={{
                  color: "#003DAA",
                  fontWeight: 500,
                  fontFamily: "poppins",
                  fontSize: "18px",
                  marginBottom: "8px"
               }}
            >
               {sectionName}
            </span>
         )}
         <div
            className={isProfilePage && (sectionName ? "sectionSpace" : "noSectionSpace")}
            style={{
               display: "flex",
               flexDirection: "column"
            }}
         >
            {isEditMode || isEditPassword || isEditEmail ? (
               <span
                  style={{
                     color: "#3A3737",
                     fontSize: "16px",
                     marginBottom: "4px",
                     fontWeight: 500
                  }}
               >
                  {isRequired && <span style={{ color: "red" }}> *</span>} {propertyName}
               </span>
            ) : (
               <span style={{ color: "#4158CF", fontSize: "16px", marginBottom: "4px" }}>
                  {propertyName}
               </span>
            )}

            {isEditMode ? (
               fieldType === "selectBaseCountry" ? (
                  <>
                     <Select
                        name={name}
                        value={propertyValue}
                        options={options}
                        showSearch
                        filterOption={(input, option) =>
                           option?.label?.toLowerCase().includes(input.toLowerCase())
                        }
                        onChange={onSelectChange}
                        placeholder={t("select-base-country-placeholder")}
                        style={{ width: "100%", marginBottom: "8px" }}
                     />
                  </>
               ) : fieldType === "selectCity" ? (
                  <>
                     <Select
                        name={name}
                        value={
                           propertyValue !== undefined && propertyValue !== null
                              ? findOption(propertyValue)
                              : null
                        }
                        options={options}
                        showSearch
                        filterOption={(input, option) =>
                           option?.label?.toLowerCase().includes(input.toLowerCase())
                        }
                        onChange={onSelectChange}
                        placeholder={t("select-a-city-placeholder")}
                        style={{ width: "100%", marginBottom: "8px" }}
                     />
                  </>
               ) : fieldType === "selectNationality" ? (
                  <Select
                     name={name}
                     value={findOption(propertyValue)}
                     options={options}
                     showSearch
                     filterOption={(input, option) =>
                        option?.label?.toLowerCase().includes(input.toLowerCase())
                     }
                     onChange={onSelectChange}
                     placeholder={`${t("select-your-prefix")} ${propertyName.toLowerCase()}`}
                     style={{ width: "100%", marginBottom: "8px" }}
                  />
               ) : fieldType === "selectOperatingCountries" ? (
                  <Select
                     isMulti
                     name={name}
                     value={propertyValue}
                     options={options}
                     showSearch
                     filterOption={(input, option) =>
                        option?.label?.toLowerCase().includes(input.toLowerCase())
                     }
                     onChange={onSelectChange}
                     placeholder={t("select-operating-countries-placeholder")}
                     style={{ width: "100%", marginBottom: "8px" }}
                  />
               ) : fieldType === "selectResidence" ? (
                  <Select
                     name={name}
                     value={findOption(propertyValue)}
                     options={options}
                     showSearch
                     filterOption={(input, option) =>
                        option?.label?.toLowerCase().includes(input.toLowerCase())
                     }
                     onChange={onSelectChange}
                     placeholder={t("select-country-of-residence-placeholder")}
                     style={{ width: "100%", marginBottom: "8px" }}
                  />
               ) : fieldType === "date" ? (
                  <DatePicker
                     name={name}
                     value={propertyValue ? dayjs(propertyValue) : null}
                     onChange={onSelectChange}
                     style={{ width: "100%" }}
                  />
               ) : fieldType === "gender" ? (
                  <Select
                     name={name}
                     value={options.find((option) => option.label === propertyValue)}
                     options={options}
                     onChange={onSelectChange}
                     placeholder={`${t("select-your-prefix")} ${propertyName.toLowerCase()}`}
                     style={{ width: "100%", marginBottom: "8px" }}
                  />
               ) : fieldType === "phone" ? (
                  <div>
                     <PhoneInput
                        name={name}
                        value={propertyValue}
                        international
                        defaultCountry="US"
                        onChange={onSelectChange}
                        className="custom-phone-input"
                     />
                  </div>
               ) : (
                  <Input
                     value={propertyValue}
                     onChange={handleChange}
                     name={name}
                     style={{
                        color: "#555",
                        fontFamily: "Lato",
                        fontSize: "14px"
                     }}
                  />
               )
            ) : isEditPassword ? (
               <div className="password-section">
                  <Input
                     type={type}
                     value={propertyValue}
                     onChange={handleChange}
                     name={name}
                     placeholder={
                        fieldType === "oldPassword"
                           ? t("enter-current-password-placeholder")
                           : fieldType === "newPassword"
                           ? t("enter-new-password-placeholder")
                           : t("enter-new-password-again-placeholder")
                     }
                     style={{
                        color: "#3A3737",
                        fontFamily: "Lato",
                        fontSize: "14px"
                     }}
                     className={`form-control`}
                     maxLength={16}
                  />
                  <img
                     className="eyeButton"
                     onClick={handleToggle}
                     src={icon}
                     alt="showPasswordIcon"
                     style={{ width: "14px" }}
                  />
               </div>
            ) : isEditEmail ? (
               <Input
                  type="email"
                  value={propertyValue}
                  onChange={handleChange}
                  name={name}
                  placeholder={t("enter-your-email-placeholder")}
                  style={{
                     color: "#3A3737",
                     fontFamily: "Lato",
                     fontSize: "14px"
                  }}
               />
            ) : Array.isArray(propertyValue) ? (
               <div style={{ display: "flex", flexWrap: "wrap" }}>
                  {propertyValue.map((item, index) => (
                     <span
                        key={item.value}
                        style={{
                           color: "#3A3737",
                           fontWeight: 600,
                           fontFamily: "Lato",
                           fontSize: "18px",
                           marginRight: index < propertyValue.length - 1 ? "5px" : "0"
                        }}
                     >
                        {item.label}
                        {index < propertyValue.length - 1 ? ", " : ""}
                     </span>
                  ))}
               </div>
            ) : (
               <span
                  style={{
                     color: "#3A3737",
                     fontWeight: 600,
                     fontFamily: "Lato",
                     fontSize: "18px"
                  }}
               >
                  {propertyValue}
               </span>
            )}
         </div>
      </div>
   );
};

export default Sections;
